import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import * as z from 'zod';

// What the repair shop card and its lead form share. The form is fetched on
// first open, so it can't import these from the card's file.

export const EVENT_CATEGORY = 'Repair Shop Locator';

const ProShopSchema = z.object({
   id: z.number(),
   name: z.string(),
   address: z.string(),
   addressUnit: z.string().nullable(),
   city: z.string(),
   state: z.string(),
   postcode: z.string(),
   country: z.string(),
   latitude: z.number(),
   longitude: z.number(),
   distanceMiles: z.number(),
   affiliation: z.enum(['microcenter', 'independent', 'repairdesk']),
   consultationUrl: z.string().optional(),
});
export type ProShop = z.infer<typeof ProShopSchema>;

export const ProShopListSchema = z.array(ProShopSchema);

export function streetAddress(shop: ProShop) {
   return shop.addressUnit ? `${shop.address}, ${shop.addressUnit}` : shop.address;
}

export function trackShopEvent({
   shop,
   placement,
   slot,
   action,
}: {
   shop: ProShop;
   placement: string;
   slot: string | undefined;
   action: string;
}) {
   trackAnalyticsCustomEvent({
      eventCategory: EVENT_CATEGORY,
      eventAction: `${placement} - ${action}`,
      eventName: `${shop.name}, ${shop.city}`,
      ...slotParam(slot),
   });
}

export function slotParam(slot: string | undefined) {
   return slot ? { slot } : {};
}
